import React, { Component } from 'react'
import {Helmet} from "react-helmet";
import '../styles/SignUp.css'

export default class SignUp extends Component {
    render() {
        return (
            <>
                <Helmet>
                    <title>Sign Up</title>
                </Helmet>
                <div className="signUp inner">
                    <div className="container">
                        <h5><i class="fas fa-user"></i> Sign Up</h5>
                        <div className="row">
                            <div className="col-md-6">
                                <form>
                                    <div className="row">
                                    <div className="col-md-6">
                                        <label>Name</label>
                                        <input type="text" />
                                    </div>
                                    <div className="col-md-6">
                                    <label>Email</label>
                                    <input type="email" />
                                    </div>
                                    <div className="col-md-6">
                                    <label>Phone</label>
                                    <input type="number" />
                                    </div>
                                    <div className="col-md-6">
                                    <label>Password</label>
                                    <input type="Password" />
                                    </div>
                                    </div>
                                    <div className="text-center">
                                    <button>Submit</button>
                                    </div>
                                    <div className="share text-center">
                                    <div><b>Follow Us</b></div>
                                    <img src="../images/facebook.png" alt="image" />
                                    <img src="../images/whatsapp.png" alt="image"/>
                                    <img src="../images/twitter.png" alt="image"/>
                                    <img src="../images/google-plus.png" alt="image"/>
                                    <img src="../images/youtube.png" alt="image"/>
                                </div>
                                </form>
                            </div>
                            <div className="col-md-6">
                                <div className="image text-center">
                                    <img src="../images/sign.png" alt="image"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
